import { Injectable } from "@angular/core";
import { GRATIFICATION_SOUND } from "src/app/core/constants/app-constants";

@Injectable({ providedIn: 'root' })
export class AudioPlayerService {

  audioPlayerMap: Map<String, HTMLAudioElement> = new Map();

  constructor() {
    this.audioPlayerMap.set('gratification', new Audio(GRATIFICATION_SOUND));
    this.audioPlayerMap.get('gratification').volume = 0.5;
  }

  init(type, url, volume = 0.1) {
    const newAudio = new Audio(url);
    newAudio.volume = volume;
    this.audioPlayerMap.set(type, newAudio);
  }

  play(type = 'gratification') {
    this.audioPlayerMap.get(type).play();
  }

}